export default `p=abs(p)-15.;
    if(p.x < p.z)p.xz=p.zx;
    if(p.y < p.z)p.yz=p.zy;
    if(p.x < p.y)p.xy=p.yx;
    float s=2.;
    for (int i=0; i<8; i++){
      p=-sign(p)*(abs(abs(abs(p)-2.)-1.)-1.);
      float r=-1.55/max(.41,dot(p,p));
      s*=r; p*=r; p-=.5;
    }
    s=abs(s);
    return dot(p,normalize(vec3(1.0,2.0,3.0)))/s;
  }`